module.exports = __webpack_public_path__ + "static/media/expert.1b3d334b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/expert.jpg
// module id = 1021
// module chunks = 0